import { instance } from '@/services/iss-nattag-api.service'
import { Train } from '@/types/train'
import { AxiosResponse } from 'axios'

const URL = 'train'

export const getTrain = (trainUuid: string): Promise<AxiosResponse<Train>> =>
  instance.get(`${URL}/${trainUuid}`)
